export var getPanelOrderIdForQueue = function (panelOrderId, biomarkerName) {
    return "".concat(panelOrderId, "_").concat(biomarkerName);
};
